import { types, flow, applySnapshot, getSnapshot } from 'mobx-state-tree';
import { makeRequest, errorResponse } from 'js/services/Network';
import ItemUsageLogs from "js/stores/types/ItemUsageLogs";

export const tokenStatusTranslation = {
  awaiting_seller: 'Waiting for a seller',
  awaiting_buyer_confirm: 'Waiting for buyer to select shipping',
  ready_to_ship: 'Waiting for seller to print label',
  ready_to_meet: 'Ready for buyer/seller to meet up',
  shipped: 'Shipped',
};

export default types
  .model('Token', {
    isLoading: false,
    error: types.maybeNull(types.string),

    alias: types.string,
    title: types.maybe(types.string),
    item_address: types.maybeNull(types.string),
    size: types.maybeNull(types.string),
    buyer_name: types.maybeNull(types.string),
    buyer_email: types.maybeNull(types.string),
    seller_name: types.maybeNull(types.string),
    seller_email: types.maybeNull(types.string),
    image: types.maybe(types.string),
    created_at: types.maybe(types.string),
    price: types.maybe(types.number),
    status: types.maybeNull(types.string),

    item_usage_logs: types.optional(types.array(ItemUsageLogs), []),
  })
  .views(self => ({
    get human_status() {
      return tokenStatusTranslation[self.status] || `Unknown status (${self.status})`;
    },
  }))
  .actions(self => ({
    load: flow(function* load() {
      let response;

      if (!self.isLoading) {
        self.isLoading = true;
        self.error = null;

        try {
          response = yield makeRequest('admin-token-data', self);
          applySnapshot(self, { ...getSnapshot(self), ...response.data });
        } catch (error) {
          self.error = errorResponse(error);
        }

        self.isLoading = false;
      }

      return response;
    }),
  }));
